import { render, staticRenderFns } from "./SendVerifyCode.vue?vue&type=template&id=9b17940a&"
import script from "./SendVerifyCode.vue?vue&type=script&lang=js&"
export * from "./SendVerifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports